jQuery(function($) {
  $('.drawer_link').on('click', function(){
    if (window.innerWidth <= 1280) {
      $('#toggle').click();
    }
  });

	$(window).scroll(function() {
		var fvHeight = $('.p-recruitLp__fv').outerHeight();
		console.log(fvHeight);
		var scrollTop = $(window).scrollTop();
		
		if (scrollTop > fvHeight) {
			$('.p-recruitLp__floating').fadeIn(200);
		} else {
			$('.p-recruitLp__floating').fadeOut(200);
		}
	});
});
